/*
 * Sidebar link to the Uptime page.
 *
 * Named "Uptime" rather than "Status" or "Kuma": it says what you get (availability over time),
 * not the tool behind it — the same rule that keeps the family's nav labelled by capability, and
 * keeps upstream product names out of our surfaces.
 */
import { SidebarItem } from '@backstage/core-components';
import TimelineIcon from '@material-ui/icons/Timeline';

import { UPTIME_PATH } from './index';

export function UptimeNavItem() {
  return <SidebarItem icon={TimelineIcon} to={UPTIME_PATH} text="Uptime" />;
}
